import { ContainerClassMap } from "../../containers/utils/ContainerMap";
export class TypedContainerController {
  constructor(node) {
    this.node = node;
    this._callbacks = [];
    this._callbacks_tmp = [];
    const container_class = ContainerClassMap[node.context()];
    this._container = new container_class(this.node);
  }
  container() {
    return this._container;
  }
  containerUnlessBypassed() {
    var _a, _b;
    if ((_b = (_a = this.node.flags) == null ? void 0 : _a.bypass) == null ? void 0 : _b.active()) {
      const inputNode = this.node.io.inputs.input(0);
      if (inputNode) {
        return inputNode.containerController.containerUnlessBypassed();
      }
    } else {
      return this.container();
    }
  }
  async compute() {
    var _a, _b;
    if ((_b = (_a = this.node.flags) == null ? void 0 : _a.bypass) == null ? void 0 : _b.active()) {
      const container = await this.requestInputContainer(0) || this._container;
      this.node.cookController.endCook();
      return container;
    }
    if (this.node.isDirty()) {
      return new Promise((resolve, reject) => {
        var _a2, _b2;
        this._callbacks.push(resolve);
        if ((_b2 = (_a2 = this.node.flags) == null ? void 0 : _a2.bypass) == null ? void 0 : _b2.active()) {
          throw "we should not be here";
        }
        this.node.cookController.cookMain();
      });
    }
    return this._container;
  }
  async requestInputContainer(input_index) {
    const inputNode = this.node.io.inputs.input(input_index);
    if (inputNode) {
      return await inputNode.compute();
    } else {
      this.node.states.error.set(`input ${input_index} required`);
      this.notifyRequesters();
      return null;
    }
  }
  notifyRequesters(container) {
    this._callbacks_tmp = this._callbacks.slice();
    this._callbacks.splice(0, this._callbacks.length);
    if (!container) {
      container = this.node.containerController.container();
    }
    let callback;
    while (callback = this._callbacks_tmp.pop()) {
      callback(container);
    }
    this.node.scene().cookController.removeNode(this.node);
  }
}
export class BaseContainerController extends TypedContainerController {
}
